// A page's view kept in its address, so a reload keeps it and a link can
// open it: the Dashboard's account, group, search and sensor, an Accounts
// dialog. Written with replaceState, so Back still leaves the page.

const params = () => new URLSearchParams(window.location.search);

export const getParam = name => {
  const v = params().get(name);
  return v == null || v === '' ? null : v;
};

// "12,40" -> [12, 40]: whole positive numbers only
export const getIdList = name => (getParam(name) || '')
  .split(',')
  .map(s => Number(s.trim()))
  .filter(n => Number.isInteger(n) && n > 0);

// { account: 12, q: null }: null or '' removes a parameter, the rest stay
export const setParams = values => {
  const p = params();
  Object.keys(values).forEach(k => {
    const v = values[k];
    if (v == null || v === '' || (Array.isArray(v) && !v.length)) p.delete(k);
    else p.set(k, Array.isArray(v) ? v.join(',') : String(v));
  });
  const q = p.toString().replace(/%2C/gi, ',');
  const url = window.location.pathname + (q ? '?' + q : '') + window.location.hash;
  if (url !== window.location.pathname + window.location.search + window.location.hash) {
    window.history.replaceState(window.history.state, '', url);
  }
};

// this page's address, for a Copy link button
export const pageLink = () => window.location.href;

// put text on the clipboard; resolves true when it got there
export const copyText = text => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).then(() => true, () => fallbackCopy(text));
  }
  return Promise.resolve(fallbackCopy(text));
};

const fallbackCopy = text => {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'fixed';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  let ok = false;
  try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
  el.remove();
  return ok;
};
